import { initializeApp } from 'firebase/app'
import { getAuth, connectAuthEmulator } from 'firebase/auth'

const debug = import.meta.env.VITE_AUTH_DEBUG === 'true'
const verbose = import.meta.env.VITE_AUTH_VERBOSE === 'true' || import.meta.env.DEV

const emulatorUrl = import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_URL
const emulatorDisableWarnings = import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_DISABLE_WARNINGS
const apiKey = import.meta.env.VITE_FIREBASE_API_KEY
const projectId = import.meta.env.VITE_FIREBASE_PROJECT_ID || import.meta.env.VITE_GCLOUD_PROJECT
const appId = import.meta.env.VITE_FIREBASE_APP_ID
const authDomain = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN

const appOptions = {}
if (apiKey) appOptions.apiKey = apiKey
if (projectId) appOptions.projectId = projectId
if (appId) appOptions.appId = appId
if (authDomain) appOptions.authDomain = authDomain

const config = {
  app: { options: appOptions }
}

if (emulatorUrl) {
  config.emulator = { url: emulatorUrl, options: {} }
  if (emulatorDisableWarnings !== undefined) {
    config.emulator.options.disableWarnings = emulatorDisableWarnings === 'true'
  }
}

if (debug) console.info('[auth]', 'config', config)

if (verbose) console.info('[auth]', 'initializing...')
let auth
try {
  const app = initializeApp(config.app.options)
  auth = getAuth(app)
  if (verbose) console.info('[auth]', 'initialized.')
  if (config.emulator) {
    if (verbose) console.info('[auth]', 'connecting to firebase emulator...')
    connectAuthEmulator(auth, config.emulator.url, config.emulator.options)
    if (verbose) console.info('[auth]', 'connected to firebase emulator...')
  }
} catch (error) {
  if (verbose) console.warn('[auth]', 'firebase initialization failed', error.message)
}

export { auth }
